<h2 mat-dialog-title>Detalles de la Bonificación</h2>
<mat-dialog-content>
  <div class="container py-3">
    <!-- Información principal -->
    <div class="row mb-4">
      <div class="col-12">
        <mat-card>
          <mat-card-content>
            <div class="row">
              <div class="col-md-6">
                <p><strong>Periodo:</strong> {{data.bonificacion.periodo}}</p>
                <p><strong>Concepto:</strong> {{data.conceptoDescripcion}}</p>
              </div>
              <div class="col-md-6">
                <p><strong>Vendedor:</strong> {{data.vendedorNombre}}</p>
                <p><strong>Valor:</strong> {{data.bonificacion.valor | currency:'COP':'symbol-narrow':'1.0-0'}}</p>
              </div>
            </div>
            <div class="row mt-2" *ngIf="data.bonificacion.observaciones">
              <div class="col-12">
                <p><strong>Observaciones:</strong> {{data.bonificacion.observaciones}}</p>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Información de auditoría -->
    <div class="row">
      <div class="col-md-6">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="fs-6">Información de Creación</mat-card-title>
          </mat-card-header>
          <mat-card-content class="pt-3">
            <p><strong>Usuario:</strong> {{data.bonificacion.usuario_creacion}}</p>
            <p><strong>Fecha:</strong> {{data.bonificacion.fecha_creacion | date:'dd/MM/yyyy'}}</p>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-6" *ngIf="data.bonificacion.usuario_modificacion">
        <mat-card>
          <mat-card-header>
            <mat-card-title class="fs-6">Última Modificación</mat-card-title>
          </mat-card-header>
          <mat-card-content class="pt-3">
            <p><strong>Usuario:</strong> {{data.bonificacion.usuario_modificacion}}</p>
            <p><strong>Fecha:</strong> {{data.bonificacion.fecha_modificacion | date:'dd/MM/yyyy'}}</p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
